<template>

<div>
    <el-row>
        <el-col :span="24">
            <div class="grid-content bg-purple-light">

                <div class="searchTitle">
                    <b style="font-size: 20px !important;">  박스 매핑 </b>
      </div>

      <!-- 조회 조건 영역 -->
      <div class="searchBody">
        <!-- 조회 조건 영역 -->

          <div class="searchBody_year" style="font-size: 15px !important;">
          매핑 일자
          </div>
          <div style="margin-left: 18px">
          <el-date-picker
            v-model="confirmStartDateOption"
            type="date"
            placeholder="Pick a day"
            value-format="yyyy-MM-dd"
            class="date-input"
          >
          </el-date-picker>
          ~
          <el-date-picker
            v-model="confirmEndDateOption"
            type="date"
            placeholder="Pick a day"
            value-format="yyyy-MM-dd"
            class="date-input"
          >
          </el-date-picker>
          </div>

      </div>



      <div class="searchBody">
        <!-- 조회 조건 영역 -->
        <div class="searchBody_year" style="font-size: 15px !important;">
          운송장번호
        </div>
        <div >
          <el-input
              placeholder=""
              v-model="inputBigQrCode"
                            class="wide-input"
              style="margin-left: 10px;"
          >
          </el-input>
        </div>

      </div>



      <div class="searchBody">
        <!-- 조회 조건 영역 -->
        <div class="searchBody_year" style="font-size: 15px !important;">
            QR CODE
        </div>
        <div >
          <el-input
              placeholder=""
              v-model="inputQrCode"
                            class="wide-input"
              style="margin-left: 10px;"
          >
          </el-input>
        </div>
      </div>




      <!--      <div class="searchBody">-->
<!--        &lt;!&ndash; 조회 조건 영역 &ndash;&gt;-->
<!--        <div class="searchBody_production" style="margin-right: 0px;width: 80px !important;">-->
<!--          QR 리딩 건수-->
<!--        </div>-->

<!--        <div>-->
<!--        <el-radio v-model="countFlag"  label="All" style="margin-right: 5px !important; padding-left: 2px !important;">전체</el-radio>-->
<!--        <el-radio v-model="countFlag"   label="Complete" style="margin-right: 5px !important; padding-left: 2px !important;">리딩완료</el-radio>-->
<!--          <el-radio v-model="countFlag"   label="Incomplete" style="margin-right: 5px !important; padding-left: 2px !important;">리딩 미완료</el-radio>-->
<!--          <el-radio v-model="countFlag"   label="Over" style="margin-right: 5px !important; padding-left: 2px !important;">리딩 오버</el-radio>-->
<!--        </div>-->

<!--      </div>-->



      <div class="searchBody"            >

        <div class="searchBody_brand">
          <el-button
            :loading="loading"
            type="primary"
            @click="search"
          >Search</el-button>
          </div>
      </div>


    </div> <!-- div class="grid-content bg-purple-light"> -->
  </el-col>

</el-row>



    <el-row>
        <el-col :span="20">
            <div class="grid-content bg-purple-light" >
 <el-table
    v-loading="loading"
    ref="multipleTable"
    :data="tableData"

    border
    @selection-change="handleSelectionChange"
     :row-class-name="tableRowClassName"
    size="small"
    :row-style="{ height: 0 + 'px' }"
    :cell-style="{ padding: 0 + 'px' }"
    :header-cell-style="{
                          background: '#2F384E',
                          color: '#fff',
                          height: '10px',
                          padding: '0px',
                        }"
 >
    <el-table-column
      type="selection"
      width="35"
      >
    </el-table-column>

    <!-- data 시작 -->
    <!-- <el-table-column
      label="Date"
      width="120">
      <template slot-scope="scope">{{ scope.row.date }}</template>
    </el-table-column> -->

    <el-table-column
        property="seq"
      label="일련번호"
      width="80">
    </el-table-column>


   <el-table-column
       property="insert_date"
       label="박스매핑작업일자"
       width="130">
   </el-table-column>



<!--   <el-table-column-->
<!--       property="waybill_number"-->
<!--       label="운송장번호"-->
<!--       width="130">-->

<!--     &lt;!&ndash;     <template slot-scope="scope">&ndash;&gt;-->
<!--     &lt;!&ndash;       <el-button type="text" size="small" @click="handleClick1(scope.row.big_qr_code ) " >&ndash;&gt;-->
<!--     &lt;!&ndash;         {{scope.row.big_qr_code}}</el-button>&ndash;&gt;-->
<!--     &lt;!&ndash;     </template>&ndash;&gt;-->

<!--   </el-table-column>-->


   <el-table-column
       property="big_qr_code"
       label="운송장번호"
       width="180">

<!--     <template slot-scope="scope">-->
<!--       <el-button type="text" size="small" @click="handleClick1(scope.row.big_qr_code ) " >-->
<!--         {{scope.row.big_qr_code}}</el-button>-->
<!--     </template>-->

   </el-table-column>


     <el-table-column
             property="total_count"
             label="소박스 매핑건수"
             width="150">

         <template slot-scope="scope">
             <el-button type="text" size="small" @click="handleClick1( scope.row.big_qr_code ) " >
                 {{scope.row.total_count}}</el-button>
         </template>
     </el-table-column>



 </el-table>




 <el-row>
  <el-col :span="24"><div class="pagination"  >

<el-pagination
  small
  layout="prev, pager, next"
      :total="totalSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
  >
</el-pagination>

<!--    <el-button-->
<!--        :loading="loading"-->
<!--        type="primary"-->
<!--        @click="excelDownFuncAll"-->
<!--    > 엑셀 다운로드 (전체)</el-button>-->


<!--    <el-tag type="warning" effect="dark"  style="margin-left: 10px; height: 30px"> COUNT : {{this.totalData.length}}</el-tag>-->



<!--      <el-button-->
<!--    :loading="loading"-->
<!--    type="primary"-->
<!--    @click="dialogVisible=true"-->
<!--  >출고 엑셀 파일 업로드</el-button>-->



    <el-button
        :loading="loading"
        type="primary"
        @click="dialogVisible2=true"
    >박스 매핑</el-button>


    <el-button
        :loading="loading"
        type="primary"
        @click="remove"
    >삭제</el-button>



    <el-button
        :loading="loading"
        type="primary"
        @click="excelDownFuncAll"
        style="margin-left: 10px"
    > 엑셀 다운로드 </el-button>



    <el-tag type="warning" effect="dark"  style="margin-left: 10px; height: 30px"> TOTAL COUNT : {{this.totalData.length}}</el-tag>

  </div>
  </el-col>
 </el-row>


    <el-dialog
  title="발행결과 파일 업로드"
  :visible.sync="dialogVisible"
  width="30%"
  v-loading="loading"
  :before-close="Confirm"
  :close-on-click-modal="false"
  custom-class="rounded-dialog"
  >
    <span class="text-reader">
      <form ref="form">

      <input type="file" @change="filesChange" class="FileUpload__default" accept=".xlsx" multiple  />
      </form>
    </span>

    <span slot="footer" class="dialog-footer">
    <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
    <el-button type="primary" @click="Confirm">Confirm</el-button>
  </span>


</el-dialog>





    <el-dialog
        title="매핑"
        :visible.sync="dialogVisible2"
        width="30%"
        v-loading="loading"
        :before-close="Confirm2"
        :close-on-click-modal="false"
        custom-class="rounded-dialog"

    >

        <el-row>
            <el-col >
                <div style="margin-top: 20px">
                  <el-input
                      id="textarea_class"
                      class="textarea_class"
                      type="textarea" v-model="qrcode"
                      @input="inputChange($event)"
                  ></el-input>


                    <div class="searchBody_production">
                <el-checkbox type="primary"   v-model="autoSave">자동 저장</el-checkbox>     <el-button type="primary" @click="qrSave">Confirm</el-button>

                    </div>
                </div>
            </el-col>
        </el-row>
    </el-dialog>




    <el-dialog
            title="QR CODE"
        :visible.sync="dialogVisible3"
        width="30%"
        v-loading="loading"
        :before-close="Confirm3"
        :close-on-click-modal="false"
            custom-class="rounded-dialog"
    >
        <el-row>
            <el-col >
                <div style="margin-top: 20px">

                  <el-input
                      id="textarea_class"
                      class="textarea_class"
                      type="textarea" v-model="qrcode2"></el-input>


    <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
                    <div style="margin-top: 10px">
                      <el-button type="primary" @click="qrSave2">Confirm</el-button>
                    </div>
                </div>
            </el-col>
        </el-row>
    </el-dialog>





<!--    <el-dialog-->
<!--        title="출고"-->
<!--        :visible.sync="dialogVisible3"-->
<!--        width="30%"-->
<!--        v-loading="loading"-->
<!--        :before-close="Confirm"-->
<!--    >-->
<!--    <span class="text-reader">-->
<!--      <form ref="form">-->
<!--      <el-input-->
<!--          id="textarea_class"-->
<!--          class="textarea_class"-->
<!--          type="textarea" v-model="qrcode"></el-input>-->
<!--      </form>-->
<!--    </span>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--    &lt;!&ndash; <el-button @click="dialogVisible = false">Cancel</el-button> &ndash;&gt;-->
<!--    <el-button type="primary" @click="Confirm2">Confirm</el-button>-->
<!--  </span>-->
<!--    </el-dialog>-->




<!--    <el-dialog-->
<!--        title=""-->
<!--        :visible.sync="dialogVisible2"-->
<!--        width="70%"-->
<!--        height="500px"-->
<!--        v-loading="loading"-->
<!--        :before-close="Confirm"-->
<!--    >-->
<!--      <el-row  class="row-bg" >-->
<!--        <el-col :span="23">-->
<!--          <div class="grid-content5">-->
<!--            <el-table-->
<!--                v-loading="loading"-->
<!--                ref="multipleTable2"-->
<!--                :data="tableData2"-->
<!--                style="width: 100%; height:100%"-->
<!--                border-->
<!--                @selection-change="handleSelectionChange"-->
<!--                :row-class-name="tableRowClassName"-->
<!--                size="small"-->
<!--                :row-style="{height:0+'px'}"-->
<!--                :cell-style="{padding:0+'px'}"-->
<!--                :header-cell-style="{background:'#f0f9eb',color:'#606266', height:'10px', padding:'0px'}"-->
<!--            >-->
<!--              <el-table-column-->
<!--                  property="waybill_number"-->
<!--                  label="운송장코드 "-->
<!--                  width="120">-->
<!--              </el-table-column>-->
<!--            </el-table>-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row >-->
<!--    </el-dialog>-->

  </div>
 </el-col>
 </el-row>

</div>
</template>


<script>
import Axios from 'axios';
import XLSX from "xlsx";


  export default {
    created() {
      this.$store.commit("dayBefore",0);
      this.confirmEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜 
      this.$store.commit("dayBefore",1);
      this.confirmStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일
      if (this.$store.state.userId != 'admin') {
        // this.deptSeqOption = this.$store.state.deptSeq;
        // this.deptNameOption = this.$store.state.deptName;
      }

      // console.log()
      // 페이지로딩시 조회
      this.search();
      // this.getFilePath();
    },//created    
    data() {
      return {
        // table 관련 data 
        tableData: [],
        totalData: [],
        totalData2: [],
        tableData2:[],
        multipleSelection: [],
        multipleTable2 :[],

        saveData:[],
        saveData2:[],
        currentPage: 1,
        pageSize:10,
        totalSize:0,

        // loading 변수 true 이면 loging 화면 보여줌
        loading:false,

        statusOptions: [{

          value: 'I',
          label: '입고'
        },
          {
          value: 'O',
          label: '출고'
        }, ],
        brandOption: '',
        styleOption :'',
        deptNameOption:'',
        deptSeqOption:0,
        confirmStartDateOption:'',
        confirmEndDateOption:'',
        statusOption:'입고',
        status:'',     
        fileList: [],
        text :[],
        dialogVisible: false,
        dialogVisible2:false,
        dialogVisible3:false,
        statusLavel:'',
        filePath:'',
        epc :'',
        member_id :'',
        member_name : '',
        chkOutDate : false,
        items : [],
        excelJsonData :  [],
        qrcode : '',
        qrcode2 : '',
        inputQrCode : '',
        inputBigQrCode : '',
        countFlag:'All',
        waybill_number : '',
        big_qr_code : '',
        autoSave  : true,
        tmpData : '',


      } // return 
    },// data

    methods: {
        inputChange(event){
            // console.log(event)
            //
            // console.log(event.length)
            //
            // console.log( event.substr(event.length - 14, 1 ) )

            if (this.autoSave) {

                if ("B" == event.substr(event.length - 13, 1)) {
                    this.qrSave();
                    this.qrcode = "";
                }else  if ("B" == event.substr(event.length - 14, 1)) {
                    this.qrSave();
                    this.qrcode = "";
                }
                else {


                    if (event.length >= 12  ) {

                        if (event.substr(-1) == '\n') {

                            var tmp = event.replace(/\n/g, "");

                            var num = Number(tmp.substr(tmp.length - 18, 18));

                            console.log ( tmp.substr(tmp.length - 18, 18) )
                            console.log ( num )

                            if (isNaN(num)) {
                                console.log(Number(event.substr(tmp.length - 18, 12) ))

                            }else {

                                // if (event.substr(event.length - 14, 1) != '=') {
                                this.qrSave();
                                this.qrcode = "";
                                // }
                            }
                        }
                    }
                }


                if (event.substr(-1) == '\n') {
                    this.tmpData = ''
                }else{
                    this.tmpData =  this.tmpData + event.substr(-1)
                }

                //console.log(this.tmpData )
                //console.log(this.tmpData.length )

            }


        },

      handleClick1(big_qr_code ){
        this.search2(big_qr_code);
      },


      async search2(big_qr_code) {
        this.loading = true;
        this.dialogVisible2 = false;
        this.dialogVisible3 = false;
        this.big_qr_code = big_qr_code;

        // default data
        let url = this.$url + '/heliodInfo/getQrList';
        var reqJson = new Object();

        reqJson.big_qr_code = big_qr_code;
        reqJson.user_seq = this.$store.state.rfid_get_order_seq;

        //console.log("============================================================") ;
        //console.log(reqJson) ;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.heliodInfoDTO;

          //console.log("=====222222222222222222================") ;
          //console.log(resDataJson) ;

          // this.qrcode2 = "";
          // this.qrcode2 = big_qr_code + '\n'

          for(var resData in resDataJson){

            this.qrcode2 = this.qrcode2 + resDataJson[resData]['qr_code'] + '\n'

          }

          //console.log("=====233333333333333332================") ;
          //console.log(this.qrcode2) ;


          // this.tableData2 =  this.totalData2
          //

          this.loading = false;
          this.dialogVisible3 = true;

        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.loading = false;
            }); // await Axios.post
      },//



      async search(){
        this.loading = true;

        // default data 
        let url = this.$url + '/heliodInfo/list';
        var reqJson = new Object();


        reqJson.in_start_date = this.confirmStartDateOption;
        reqJson.in_end_date = this.confirmEndDateOption;
        reqJson.big_qr_code = this.inputBigQrCode;
        reqJson.qr_code = this.inputQrCode;
        reqJson.user_seq = this.$store.state.rfid_get_order_seq;




        //console.log("============================")
        //console.log(reqJson.status);

        if (this.countFlag != "All")
          reqJson.count_flag  = this.countFlag ;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {

            console.log(res.data);


          var resDataJson = res.data.heliodInfoDTO;
          this.totalData=[];




          if (res.data.resultCode){

            for (var resData in resDataJson) {

                this.totalData.push({
                  seq: resData  * 1 + 1
                  , insert_date : resDataJson[resData]['insert_date']
                  , big_qr_code : resDataJson[resData]['big_qr_code']
                  , total_count : resDataJson[resData]['total_count']

                  , user_seq : this.$store.state.rfid_get_order_seq
                });

            }
            // 전체 데이터 사이즈 
            this.totalSize = this.totalData.length;
            // 보여주는 부분만 slice 
            this.tableData = this.totalData.slice(0, this.pageSize);
            this.currentPage = 1;
            this.loading = false;
            this.status = reqJson.status;
            this.$message.success(this.$store.state.searchSuccess);
          }else{
            this.$message.error(this.$store.state.dataNotFound);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
        .catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      },//search

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      }, //toggleSelection

      // check box click event 
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex === 1) {
        //  return 'warning-row';
        } else if (rowIndex === 3) {
        //  return 'success-row';
        }
         console.log(row);
        return '';
      },    
      handleSizeChange(val) {
        console.log(`${val} items per page`);
      },

      // pagging event 
      handleCurrentChange(val) {
        this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
      },
      //
      // async excelDownFunc(){
      //
      //   if(this.multipleSelection==null || this.multipleSelection.length == 0 ){
      //     this.$message.error(this.$store.state.noDataSelect);
      //     return ;
      //   }
      //
      //   this.loading = true;
      //
      //   // default data
      //   let url = this.$url + '/rfidInfo/reDowload';
      //   // var reqJson = new Object();
      //
      //   await Axios.post(url, this.multipleSelection , this.$store.state.config ).then(res => {
      //     let saveCount = res.data;
      //
      //
      //     if (saveCount){
      //       this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
      //       this.loading = false;
      //
      //     }else{
      //       this.$message.error(this.$store.state.serverErrorMessage);
      //       this.currentPage = 1;
      //       this.loading = false;
      //     }
      //   }) // await Axios.post
      //       .catch(error => {
      //         console.log(error.response)
      //         this.$message.error(this.$store.state.serverErrorMessage);
      //         this.currentPage = 1;
      //         this.loading = false;
      //       }); // await Axios.post
      //
      //
      // }, //excelDownFunc



      async pathUpload(){


        this.loading = true;

        // default data
        let url = this.$url + '/saveInfo/pathUpdate';
        var reqJson = new Object();


        reqJson.file_full_path = this.filePath;
        reqJson.user_seq = this.$store.state.rfid_get_order_seq;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          let saveCount = res.data;

          if (saveCount){
            this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
            this.loading = false;

          }else{
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.currentPage = 1;
              this.loading = false;
            }); // await Axios.post


      }, //excelDownFunc

      getCheckSum(hex)
      {
        var chk = hex.length
        var value = 0;
        for(var i=0; i <hex.length; i += 2) {
          value +=  parseInt(hex.substring(i, i+2),16) * chk
          chk ++;
        }
        var res = value * 1224 % 100;
        if (res <= 9)
          return '0' + res;
        else
          return res;
      },

      convertToHex(str) {
          var hex = '';
          for(var i=0;i<str.length;i++) {
            hex += str.charCodeAt(i).toString(16);
          }
        return hex;
      },

      convertToString(hex) {

        //console.log("convertToString");
        //console.log(hex);

        var str = '';
        for(var i=0;i<hex.length; i += 2) {
          str += String.fromCharCode(parseInt(hex.substring(i, i+2),16))
        }
        return str;
      },

      filesChange(event) {
        // get File object from input tag
        this.loading = true;

        const file = event.target.files[0];
        let reader = new FileReader();
        let tmpResult = {};
        reader.onload = (e) => {

          console.log(e);

          let data = reader.result;
          let workbook = XLSX.read(data, {type: 'binary'});
          workbook.SheetNames.forEach(sheetName => {
            workbook.Sheets[sheetName].A1.w = "region";
            workbook.Sheets[sheetName].B1.w = "waybill_number";
            workbook.Sheets[sheetName].C1.w = "sender";
            workbook.Sheets[sheetName].D1.w = "sender_hp";

            workbook.Sheets[sheetName].E1.w = "sender_manager";
            workbook.Sheets[sheetName].F1.w = "sender_manager_hp";
            workbook.Sheets[sheetName].G1.w = "sender_zip_code";
            workbook.Sheets[sheetName].H1.w = "sender_address";

            workbook.Sheets[sheetName].I1.w = "receiver";
            workbook.Sheets[sheetName].J1.w = "receiver_hp";
            workbook.Sheets[sheetName].K1.w = "receiver_manager";
            workbook.Sheets[sheetName].L1.w = "receiver_manager_hp";

            workbook.Sheets[sheetName].M1.w = "receiver_zip_code";
            workbook.Sheets[sheetName].N1.w = "receiver_address";
            workbook.Sheets[sheetName].O1.w = "fare_type";

            workbook.Sheets[sheetName].P1.w = "payment_type";
            workbook.Sheets[sheetName].Q1.w = "release_number";


            workbook.Sheets[sheetName].R1.w = "remark";

            workbook.Sheets[sheetName].S1.w = "memo1";
            workbook.Sheets[sheetName].T1.w = "memo2";

            workbook.Sheets[sheetName].U1.w = "memo3";
            workbook.Sheets[sheetName].V1.w = "memo4";

            workbook.Sheets[sheetName].W1.w = "lbl_hub_code";
            workbook.Sheets[sheetName].X1.w = "product_name1";
            workbook.Sheets[sheetName].Y1.w = "product_count1";


            workbook.Sheets[sheetName].Z1.w = "product_name2";
            workbook.Sheets[sheetName].AA1.w = "product_count2";
            workbook.Sheets[sheetName].AB1.w = "product_name3";
            workbook.Sheets[sheetName].AC1.w = "product_count3";


            workbook.Sheets[sheetName].AD1.w = "product_name4";
            workbook.Sheets[sheetName].AE1.w = "product_count4";
            workbook.Sheets[sheetName].AF1.w = "product_name5";
            workbook.Sheets[sheetName].AG1.w = "product_count5";

            workbook.Sheets[sheetName].AH1.w = "product_name6";
            workbook.Sheets[sheetName].AI1.w = "product_count6";
            workbook.Sheets[sheetName].AJ1.w = "product_name7";
            workbook.Sheets[sheetName].AK1.w = "product_count7";



            workbook.Sheets[sheetName].AL1.w = "product_name8";
            workbook.Sheets[sheetName].AM1.w = "product_count8";

            workbook.Sheets[sheetName].AN1.w = "product_name9";


            workbook.Sheets[sheetName].AO1.w = "product_count9";
            workbook.Sheets[sheetName].AP1.w = "product_name10";
            workbook.Sheets[sheetName].AQ1.w = "product_count10";
            workbook.Sheets[sheetName].AR1.w = "product_name11";


            workbook.Sheets[sheetName].AS1.w = "product_count11";
            workbook.Sheets[sheetName].AT1.w = "product_name12";


            workbook.Sheets[sheetName].AU1.w = "product_count12";


            workbook.Sheets[sheetName].AV1.w = "product_name13";


            workbook.Sheets[sheetName].AW1.w = "product_count13";
            workbook.Sheets[sheetName].AX1.w = "product_name14";
            workbook.Sheets[sheetName].AY1.w = "product_count14";
            workbook.Sheets[sheetName].AZ1.w = "product_name15";




            workbook.Sheets[sheetName].BA1.w = "product_count15";
            workbook.Sheets[sheetName].BB1.w = "product_name16";
            workbook.Sheets[sheetName].BC1.w = "product_count16";
            workbook.Sheets[sheetName].BD1.w = "product_name17";
            workbook.Sheets[sheetName].BE1.w = "product_count17";
            workbook.Sheets[sheetName].BF1.w = "product_name18";


            workbook.Sheets[sheetName].BG1.w = "product_count18";
            workbook.Sheets[sheetName].BH1.w = "product_name19";
            workbook.Sheets[sheetName].BI1.w = "product_count19";
            workbook.Sheets[sheetName].BJ1.w = "product_name20";


            workbook.Sheets[sheetName].BK1.w = "product_count20";
            workbook.Sheets[sheetName].BL1.w = "product_name21";
            workbook.Sheets[sheetName].BM1.w = "product_count21";
            workbook.Sheets[sheetName].BN1.w = "product_name22";


            workbook.Sheets[sheetName].BO1.w = "product_count22";
            workbook.Sheets[sheetName].BP1.w = "product_name23";
            workbook.Sheets[sheetName].BQ1.w = "product_count23";


            workbook.Sheets[sheetName].BR1.w = "product_name24";
            workbook.Sheets[sheetName].BS1.w = "product_count24";
            workbook.Sheets[sheetName].BT1.w = "product_name25";
            workbook.Sheets[sheetName].BU1.w = "product_count25";


            workbook.Sheets[sheetName].BV1.w = "product_name26";
            workbook.Sheets[sheetName].BW1.w = "product_count26";


            //console.log(workbook.Sheets[sheetName].A1);
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            tmpResult = roa;
          });

          //console.log("=====================================");
          //console.log(tmpResult);
          this.excelJsonData=tmpResult;


          let url = "";
          url = this.$url + '/heliodInfo/insert';

          Axios.post(url, this.excelJsonData , this.$store.state.config  ).then(res => {

            //console.log(res);
            let saveCount = res.data;
            this.loading = false;
            this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
            this.search();
            // this.$refs.myFiles.files[0].name = null;
          }).catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post



        };
        reader.readAsBinaryString(file);
              
      },//filesChange

      Confirm(){
        // this.e.target.files[0].name = "";

        this.$refs.form.reset() ;
        this.dialogVisible = false;
        this.dialogVisible2 = false;
        this.search();



      },

      Confirm2(){
        // this.e.target.files[0].name = "";

        //console.log ("Confirm2") ;
        this.qrcode = "";
        this.dialogVisible2 = false;
        this.search();

      },

      Confirm3(){
        // this.e.target.files[0].name = "";

        this.qrcode2 = "";
        this.dialogVisible3 = false;

      },


      qrSave(){


        // this.e.target.files[0].name = "";

        var array = this.qrcode.split('\n');

        var resDataJson = [];

        if (array.length < 2)
        {
          this.$message.error("저장할 데이터가 없습니다. ");
          return ;
        }

        this.loading = true;


        for ( var idx = 0 ; idx < array.length  ; idx++ ) {
              resDataJson.push({
                 qr_code: array[idx]
                ,user_seq : this.$store.state.rfid_get_order_seq
              });
        }

        let url = this.$url + '/heliodInfo/qrInsert';

        Axios.post(url, resDataJson , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          // this.search();
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.loading = false;
        }); // await Axios.post

      },



      qrSave2(){
        // this.e.target.files[0].name = "";

        var array = this.qrcode2.split('\n');

        var resDataJson = [];

          for ( var idx = 0 ; idx < array.length  ; idx++ ) {
              resDataJson.push({
                  qr_code: array[idx]
                  ,big_qr_code  : this.big_qr_code
                  ,user_seq : this.$store.state.rfid_get_order_seq
              });
          }



        //console.log ("test ")
        //console.log (array.length )
        //console.log (array[0].trim() )
        //
        // if (array.length  <= 1 && array[0].trim() == "")
        // {
        //   resDataJson = [];
        //   resDataJson.push({
        //     qr_code: this.waybill_number
        //     ,user_seq : this.$store.state.rfid_get_order_seq
        //   });
        // }

        //console.log (resDataJson )

        let url = this.$url + '/heliodInfo/qrInsert2';

        Axios.post(url, resDataJson , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search();
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.loading = false;
        }); // await Axios.post

      },


      submitUpload() {
        this.$refs.upload.submit();
      },

      async excelDownFuncAll(){


        this.loading = true;

        // default data
        let url = this.$url + '/heliodInfo/getQrList';
        var reqJson = new Object();
        var excepData=[];


        reqJson.in_start_date = this.confirmStartDateOption;
        reqJson.in_end_date = this.confirmEndDateOption;
        reqJson.big_qr_code = this.inputBigQrCode;
        reqJson.qr_code = this.inputQrCode;
        reqJson.user_seq = this.$store.state.rfid_get_order_seq;


        //console.log("============================")
        //console.log(reqJson.status);

        if (this.countFlag != "All")
          reqJson.count_flag  = this.countFlag ;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.heliodInfoDTO;



          if (res.data.resultCode){

            for (var resData in resDataJson) {

              // this.tmpData.push({
              //   seq: resData  * 1 + 1
              //   , insert_date : resDataJson[resData]['insert_date']
              //   , big_qr_code : resDataJson[resData]['big_qr_code']
              //   , total_count : resDataJson[resData]['total_count']
              //   , waybill_number:  resDataJson[resData]['waybill_number']
              // });

              excepData.push({
                일련번호 : resData  * 1 + 1
                ,작업일자 : resDataJson[resData]['insert_date']
                ,운송장번호 : resDataJson[resData]['big_qr_code']
                ,QRCODE :  resDataJson[resData]['qr_code']
              });


            }

          }else{
            this.$message.error(this.$store.state.dataNotFound);
            this.loading = false;
          }
        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.currentPage = 1;
              this.loading = false;
            }); // await Axios.post




        // var excepData = [];
        //
        // for (var i in this.tmpData) {
        //   excepData.push({
        //     일련번호 : this.totalData[i]['seq']
        //     ,작업일자 : this.totalData[i]['insert_date']
        //     ,대박스번호 : this.totalData[i]['big_qr_code']
        //     ,소박스매핑건수 : this.totalData[i]['total_count']
        //   });
        // }
        //
        // this.loading = true;
        var dataWS = XLSX.utils.json_to_sheet(excepData);
        var wb = XLSX.utils.book_new();
        // workbook에 워크시트 추가
        // 시트명은 'nameData'
        XLSX.utils.book_append_sheet(wb, dataWS, '헬리오드박스매핑');
        // 엑셀 파일을 내보낸다.
        this.$store.commit("dayBefore",0); // 오늘날짜
        XLSX.writeFile(wb, "헬리오드박스매핑"+'.xlsx');
        this.loading = false;


      },//excelDownFunc



      async remove(){
        if (this.multipleSelection.length <= 0)
        {
          this.$message.error("데이터를 선택하세요 ");
          return ;
        }
        this.loading = true;
        let url = "";
        url = this.$url + '/heliodInfo/remove';
        Axios.post(url, this.multipleSelection , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 삭제 되었습니다.');
          this.search(false);

        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      }, // remove



    }, //methods
  }
</script>


<style>
.el-dialog__body {
  padding: 10px 20px !important;
}

.textarea_class {
  height: 300px !important;
}

.el-textarea__inner {
  height: 100% !important;
}

.searchBody_production {
  width: 100px !important;
  margin-left: 20px !important;
}

</style>

